import { ArcElement, Chart as ChartJS, registerables } from 'chart.js';
import React, { FC, useContext, useEffect, useState } from "react";
import { Bar } from 'react-chartjs-2';

interface IProps {
    recordStats: number[] | any,
    backgroundColours: string[],
    borderColours: string[],
    labels: string[],
    label: string
}

interface IPropsBasic {
    values: number[] | any,
    backgroundColours: string[],
    borderColours: string[],
    labels: string[],
    label: string
}

ChartJS.register(ArcElement, ...registerables);

const StatsChart: FC<IProps> = ({ recordStats, backgroundColours, borderColours, labels, label }) => {

    const [chartData, setChartData] = useState<any>();
    
    useEffect(() => {
        if (recordStats.length > 0 ) {
            getChartData();
        }
    }, [recordStats]);

    const getChartData = () => {

        let dataVal: number[] = recordStats;
        const data = {
            labels: labels,
            datasets: [
                {
                    label: label,
                    data: dataVal,
                    backgroundColor: backgroundColours,
                    borderColor: borderColours,
                    borderWidth: 1,
                },
            ],
        };

        setChartData(data);
    }

    if (chartData) {
        return (
            <Bar data={chartData} />
        );
    } else {
        return <></>
    }
}

export const StatsChartBasic: FC<IPropsBasic> = ({ values, backgroundColours, borderColours, labels, label }) => {

    const [chartData, setChartData] = useState<any>();

    useEffect(() => {
        getChartData();
    }, []);

    const getChartData = () => {
        const data = {
            labels: labels,
            datasets: [
                {
                    label: label,
                    data: values,
                    backgroundColor: backgroundColours,
                    borderColor: borderColours,
                    borderWidth: 1,
                },
            ],
        };

        setChartData(data);
    }

    if (chartData) {
        return (
            <Bar data={chartData} />
        );
    } else {
        return <div>No Data Found</div>
    }
}

export default StatsChart;